// DocSource.tsx — the file itself, beside the page describing it.
//
// The summary is docdaemon's reading of a file; this is the file. Having both
// a click apart is what makes a summary checkable — a description that sounds
// plausible and a function that does something else is the failure mode of
// generated documentation, and it is invisible until the two are side by side.
//
// Highlighted with the language the server derived from the extension, never
// by auto-detection: hljs guesses confidently and is often wrong on a config
// file, and a YAML file coloured as Perl is worse than one not coloured at
// all. An extension it does not recognise renders as plain text.
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import type { SourceFile } from '../api';
import CodeBlock from './CodeBlock';

export default function DocSource({ file, error }: {
  file: SourceFile | null;
  error: string;
}) {
  if (error) return <Alert variant="danger" className="m-0">{error}</Alert>;
  if (!file) {
    return <div className="d-flex justify-content-center py-4"><Spinner animation="border" size="sm" /></div>;
  }
  return (
    <div>
      {/* A prefix that looked complete would be worse than refusing: the
          reader is here to check a claim against the code, and the part that
          settles it may be in the half that was cut. */}
      {file.truncated && (
        <Alert variant="warning" className="py-2 small">
          This file is larger than the viewer will fetch — you are reading the beginning of it.
        </Alert>
      )}
      <CodeBlock className="doc-source" code={file.content} language={file.language} />
    </div>
  );
}
